import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import BurgerMenuNavigationItem from './BurgerMenuNavigationItem';
import { BurgerMenuNavigationProps } from './index';

const componentName = 'burger-menu-navigation';

const BurgerMenuNavigation = ({ closeBurgerMenu, navigation }: BurgerMenuNavigationProps) => {
    if (!navigation.mainNavigationItems.length) {
        return SKIP_RENDER;
    }

    return (
        <nav className={`${componentName}`}>
            <ul className={`${componentName}__list`}>
                {navigation.mainNavigationItems.map((item) => (
                    <BurgerMenuNavigationItem key={item.link.text} closeBurgerMenu={closeBurgerMenu} item={item} />
                ))}
            </ul>
        </nav>
    );
};

export default BurgerMenuNavigation;
